import { PRODUCT_PAGES } from "./products";
import { ISDE_SEO } from "./isdeContent";

// Standaardteksten die via Beheer → Teksten aangepast kunnen worden (lege aanpassing = deze tekst).
export const PAGE_TEXTS = {
  home: {
    label: "Homepage (/)",
    path: "/",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Kunststof en aluminium kozijnen Zuid-Holland | Maas Kozijn",
        body: "Nieuwe kunststof en aluminium kozijnen, schuifpuien en deuren, compleet geleverd en gemonteerd. Gratis inmeten en een vrijblijvende prijsindicatie." },
      hero: { key: "hero", label: "Bovenaan (tekst na de eerste komma krijgt de accentkleur)",
        title: "Kunststof en aluminium kozijnen, compleet geleverd en gemonteerd.",
        body: "Wij verzorgen het complete traject voor woningen in Maassluis en heel Zuid-Holland: van het inmeten en demonteren van uw oude kozijnen tot de nette afwerking." },
      waarom: { key: "waarom", label: "Waarom Maas Kozijn",
        title: "Complete levering en montage, met één vast aanspreekpunt",
        body: "Nieuwe kozijnen zijn een flinke investering. Daarom regelen wij alles in één hand, met duidelijke afspraken, goede materialen en zorgvuldige montage." },
      offerte: { key: "offerte", label: "Offerte vergelijken",
        title: "Heeft u al een kozijnenofferte ontvangen? Laat deze vrijblijvend vergelijken.",
        body: "Upload uw offerte als PDF, foto of screenshot, of vul alleen het bedrag in. Wij bekijken persoonlijk wat er wel en niet in zit, en wat dat voor uw woning betekent." },
      isde: { key: "isde", label: "ISDE-subsidiecheck",
        title: "Nieuwe kozijnen? Check of u mogelijk ISDE-subsidie krijgt.",
        body: "Bij het vervangen van bestaande kozijnen met isolatieglas kunt u onder voorwaarden subsidie ontvangen. Met de subsidiecheck ziet u in een paar minuten wat mogelijk is voor uw woning." },
    },
  },
  projecten: {
    label: "Projecten (/projecten)",
    path: "/projecten",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Uitgevoerde kozijnprojecten in Zuid-Holland | Maas Kozijn",
        body: "Bekijk projecten die Maas Kozijn zelf uitvoerde: kunststof en aluminium kozijnen, schuifpuien en deuren, met materialen, montage en afwerking per woning." },
      hero: { key: "hero", label: "Bovenaan, zolang er nog geen project gepubliceerd is",
        title: "Onze kozijnprojecten",
        body: "Op deze pagina delen wij projecten van Maas Kozijn, met aandacht voor materialen, montage en afwerking. De projectgalerij wordt aangevuld zodra nieuwe projecten zijn gecontroleerd en gepubliceerd." },
      hero_live: { key: "hero_live", label: "Bovenaan, zodra er gepubliceerde projecten zijn",
        title: "Onze kozijnprojecten",
        body: "Op deze pagina delen wij projecten van Maas Kozijn, met aandacht voor materialen, montage en afwerking. Ieder project is door ons uitgevoerd en vóór publicatie gecontroleerd." },
      empty: { key: "empty", label: "Tijdelijke melding (verdwijnt bij het eerste gepubliceerde project)",
        title: "Alvast inspiratie opdoen?",
        body: "Ontdek verschillende mogelijkheden voor kunststof en aluminium kozijnen, schuifpuien en deuren in onze inspiratiegalerij." },
    },
  },
  inspiratie: {
    label: "Inspiratiegalerij (/projecten/inspiratie)",
    path: "/projecten/inspiratie",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Inspiratie kozijnen, schuifpuien en deuren | Maas Kozijn",
        body: "Inspiratiegalerij met kunststof en aluminium kozijnen, schuifpuien en voordeuren in wit, antraciet, zwart en houtlook. Filter op stijl, kleur en materiaal." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Inspiratie voor kozijnen, schuifpuien en deuren",
        body: "Blader door mogelijke uitvoeringen in kunststof en aluminium, van klassiek wit tot strak zwart. Dit zijn inspiratiebeelden: ze laten zien wat mogelijk is en zijn geen door Maas Kozijn uitgevoerde projecten." },
      guide: { key: "guide", label: "Tekst onder de galerij",
        title: "Van inspiratie naar een uitvoering die bij uw woning past",
        body: "Een beeld dat u aanspreekt is een goed begin. Of een uitvoering ook bij uw woning past, hangt af van de gevel, de bestaande kozijnmaten, de indeling en de gewenste isolatiewaarde.\n\nKies bij een beeld voor 'Deze uitvoering aanvragen'. Het product en het beeldnummer staan dan al in uw aanvraag, zodat wij direct zien wat u voor ogen heeft.\n\n- Klassieke woningen en jaren-30 woningen: vaak crèmewit of wit, met roedes en een rustige indeling.\n- Moderne woningen en aanbouwen: antraciet of zwart, met grote glasvlakken of een schuifpui.\n- Houtlook: de uitstraling van hout, met het lage onderhoud van kunststof." },
    },
  },
  kosten: {
    label: "Kosten (/kosten-kunststof-kozijnen-zuid-holland)",
    path: "/kosten-kunststof-kozijnen-zuid-holland",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Kosten nieuwe kozijnen in Zuid-Holland (2026) | Maas Kozijn",
        body: "Wat kosten nieuwe kunststof of aluminium kozijnen, schuifpuien en deuren? Lees welke factoren de prijs bepalen en wat er in een prijs hoort te zitten." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Kosten nieuwe kozijnen in Zuid-Holland (2026)",
        body: "Wat nieuwe kozijnen kosten, hangt af van uw woning en uw keuzes. Op deze pagina leest u welke factoren de prijs bepalen, wat er in een goede prijs hoort te zitten en hoe u prijzen eerlijk vergelijkt." },
    },
  },
  montage: {
    label: "Montage (/montage)",
    path: "/montage",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Kozijnmontage: zo plaatsen wij nieuwe kozijnen | Maas Kozijn",
        body: "Van inmeten en demontage tot luchtdichte aansluiting en afwerking: lees stap voor stap hoe nieuwe kunststof en aluminium kozijnen worden geplaatst." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Montage van nieuwe kozijnen, stap voor stap",
        body: "Een goed kozijn presteert pas goed als het zorgvuldig is geplaatst. Hier leest u hoe een kozijnvervanging verloopt: van inmeten en demontage tot afdichten, afwerken en opleveren." },
    },
  },
  glas: {
    label: "HR++ / HR+++ glas (/hr++-glas-isolatieglas)",
    path: "/hr++-glas-isolatieglas",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "HR++ of HR+++ glas: verschillen en advies | Maas Kozijn",
        body: "HR++ of HR+++ (triple) glas in nieuwe kozijnen? Vergelijk isolatiewaarde, gewicht, geluid en meerprijs, en lees wanneer triple glas zinvol is." },
      hero: { key: "hero", label: "Bovenaan",
        title: "HR++ of HR+++ glas in uw nieuwe kozijnen",
        body: "Nieuwe kozijnen leveren wij met isolatieglas. Maar kiest u voor HR++ of voor HR+++ (triple) glas? Hier vergelijken we de twee eerlijk: isolatie, comfort, gewicht en kosten." },
    },
  },
  werkwijze: {
    label: "Werkwijze (/werkwijze)",
    path: "/werkwijze",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Werkwijze: van aanvraag tot oplevering | Maas Kozijn",
        body: "Zo werkt Maas Kozijn: aanvraag met foto's, persoonlijke prijsindicatie, gratis inmeten, heldere offerte, montage en oplevering van uw nieuwe kozijnen." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Onze werkwijze: van aanvraag tot oplevering",
        body: "Nieuwe kozijnen zijn een grote stap. Daarom weet u bij ons vooraf wat u kunt verwachten: van de eerste vraag en het inmeten tot de montage, de afwerking en de oplevering." },
    },
  },
  werkgebied: {
    label: "Werkgebied (/werkgebied)",
    path: "/werkgebied",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Werkgebied Zuid-Holland: kozijnen in uw plaats | Maas Kozijn",
        body: "Maas Kozijn uit Maassluis plaatst kunststof en aluminium kozijnen, schuifpuien en deuren in Zuid-Holland, van Vlaardingen en Rotterdam tot Den Haag en Delft." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Nieuwe kozijnen in uw plaats in Zuid-Holland",
        body: "Maas Kozijn is gevestigd in Maassluis en levert en monteert complete nieuwe kunststof en aluminium kozijnen, schuifpuien en deuren in Zuid-Holland. Kies uw plaats voor informatie over de wijken, woningtypes en aandachtspunten bij u in de buurt." },
      vestiging: { key: "vestiging", label: "Vestiging en werkgebied",
        title: "Gevestigd in Maassluis, actief in Zuid-Holland",
        body: "Maas Kozijn is gevestigd in Maassluis. Vanuit daar werken we in Zuid-Holland, met de nadruk op Maassluis, Vlaardingen, Schiedam en Rotterdam. Ook in Den Haag, Delft, het Westland, Spijkenisse, Rijswijk, Zoetermeer, Capelle aan den IJssel en Lansingerland komen we langs.\n\nWij leveren altijd complete nieuwe kozijnen, puien en deuren, inclusief glas en montage. Inmeten doen we bij u thuis, zodat we de situatie ter plekke kunnen beoordelen." },
      missing: { key: "missing", label: "Staat uw plaats er niet bij?",
        title: "Staat uw plaats er niet bij?",
        body: "Ook buiten de plaatsen hierboven kunnen we u vaak helpen, zolang uw woning in Zuid-Holland ligt. Vraag een prijsindicatie aan of stuur een bericht via WhatsApp; we laten u snel weten of we bij u langs kunnen komen." },
    },
  },
  grotepuien: {
    label: "Grote puien (/grote-puien)",
    path: "/grote-puien",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Grote puien en hefschuifpuien op maat | Maas Kozijn",
        body: "Grote puien in kunststof en aluminium: schuifpuien, hefschuifpuien en vaste glasvlakken. Lees over glaskeuze, techniek, montage en afwerking." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Grote puien: meer licht en een open verbinding met de tuin",
        body: "Een brede glazen pui verandert hoe uw woonkamer aanvoelt. Wij helpen u kiezen tussen kunststof en aluminium, schuifpui en hefschuifpui, en zorgen voor een zorgvuldige montage en een nette afwerking." },
    },
  },
  materiaal: {
    label: "Kunststof of aluminium (/aluminium-of-kunststof-kozijnen)",
    path: "/aluminium-of-kunststof-kozijnen",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Kunststof of aluminium kozijnen? De verschillen | Maas Kozijn",
        body: "Kunststof of aluminium kozijnen? Vergelijk isolatie, onderhoud, levensduur, uitstraling, profielsystemen en toepassingen, en lees wanneer welk materiaal past." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Kunststof of aluminium kozijnen: wat past bij uw woning?",
        body: "Beide materialen isoleren goed en vragen weinig onderhoud. De verschillen zitten in uitstraling, profielbreedte, grote glasvlakken en prijsniveau. Hier zetten we ze eerlijk naast elkaar." },
      advice: { key: "advice", label: "Advies onder de vergelijking",
        title: "Twijfelt u nog?",
        body: "In de praktijk hangt de beste keuze af van uw woning, de gevel, de gewenste glasvlakken en uw budget. Veel woningen combineren ook beide: kunststof kozijnen rondom en een aluminium schuifpui aan de tuinzijde.\n\nVertel ons wat u voor ogen heeft. Wij adviseren eerlijk welk materiaal en welk profielsysteem het beste past, zonder u een richting op te duwen." },
    },
  },
  faq: {
    label: "Veelgestelde vragen (/veelgestelde-vragen)",
    path: "/veelgestelde-vragen",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Veelgestelde vragen over kozijnen, puien en deuren | Maas Kozijn",
        body: "Antwoorden op veelgestelde vragen over kunststof en aluminium kozijnen, schuifpuien, deuren, glas, montage, kosten en ISDE-subsidie." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Veelgestelde vragen",
        body: "Korte, duidelijke antwoorden over kozijnen, schuifpuien, deuren, glas, montage, kosten en subsidie. Staat uw vraag er niet bij? Stel hem gerust via WhatsApp of bel ons." },
    },
  },
  kennisbank: {
    label: "Kennisbank (/blog)",
    path: "/blog",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Kennisbank: advies over kozijnen, puien en glas | Maas Kozijn",
        body: "Praktische artikelen over kunststof en aluminium kozijnen, schuifpuien, deuren, HR++ glas, montage, kosten en subsidie. Eerlijk advies van Maas Kozijn." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Kennisbank",
        body: "Eerlijke uitleg over materialen, glas, montage, kosten en subsidie. Zo weet u wat u kiest en waarom, voordat u een offerte aanvraagt." },
    },
  },
  overons: {
    label: "Over ons (/over-ons)",
    path: "/over-ons",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Over Maas Kozijn | Kozijnspecialist uit Maassluis",
        body: "Maas Kozijn uit Maassluis levert en monteert kunststof en aluminium kozijnen, schuifpuien en deuren in Zuid-Holland, met GEALAN-profielen en ervaren monteurs." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Maas Kozijn: nieuwe kozijnen uit Maassluis, vakkundig geplaatst",
        body: "Wij leveren en monteren complete nieuwe kunststof en aluminium kozijnen, schuifpuien en deuren voor particuliere woningeigenaren in Zuid-Holland. Met kwaliteitsmaterialen, ervaren vakmensen en duidelijke afspraken." },
      wie: { key: "wie", label: "Wie wij zijn",
        title: "Een persoonlijk kozijnbedrijf uit Maassluis",
        body: "Maas Kozijn is gevestigd in Maassluis en richt zich op de levering en professionele montage van complete nieuwe kozijnen, schuifpuien en deuren. Eigenaar Hilmi Yildirimer is uw vaste aanspreekpunt: van de eerste vraag tot de oplevering.\n\nOns doel is eenvoudig: kwalitatieve kozijnen toegankelijk maken voor woningeigenaren in Zuid-Holland. Dat betekent een eerlijk advies, een offerte waarin staat wat u krijgt, en montage door vakmensen die weten wat een nette aansluiting is." },
      vakmanschap: { key: "vakmanschap", label: "Vakmanschap en montage",
        title: "Ervaren vakmensen, zorgvuldige montage",
        body: "Maas Kozijn werkt samen met ervaren zelfstandige vakmensen. Onze hoofdmonteur heeft persoonlijk ruim 20 jaar praktijkervaring in kozijnmontage. Die ervaring brengt hij mee naar elk project, van het demonteren van de oude kozijnen tot het afdichten en afwerken van de nieuwe.\n\nHoe groot de ploeg op een project is, hangt af van de omvang van het werk. Wat altijd gelijk blijft: we plaatsen de kozijnen waterpas en in lood, dichten de aansluitingen zorgvuldig af en werken af zoals vooraf is afgesproken." },
      werkgebied: { key: "werkgebied", label: "Werkgebied",
        title: "Vanuit Maassluis in heel Zuid-Holland",
        body: "Vanuit Maassluis werken wij voor particuliere woningeigenaren in Zuid-Holland, met de nadruk op Maassluis, Vlaardingen, Schiedam en Rotterdam. Inmeten doen we altijd bij u thuis, zodat we de situatie ter plekke kunnen beoordelen." },
    },
  },
  contact: {
    label: "Contact (/contact)",
    path: "/contact",
    blocks: {
      seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true,
        title: "Contact | Maas Kozijn in Maassluis – bel, app of mail",
        body: "Neem contact op met Maas Kozijn uit Maassluis via telefoon, WhatsApp, e-mail of het contactformulier. Of vraag direct een vrijblijvende prijsindicatie aan." },
      hero: { key: "hero", label: "Bovenaan",
        title: "Contact met Maas Kozijn",
        body: "Heeft u een vraag over kozijnen, schuifpuien of deuren, of wilt u een afspraak maken? Bel, app of mail ons, of kies hieronder uw onderwerp. Voor een prijsindicatie gaat u direct naar het aanvraagformulier." },
    },
  },
};

// Pagina's waarvan alleen de SEO-titel en metabeschrijving via Beheer → Teksten aanpasbaar zijn (inhoud staat in de code).
const seoOnly = (label, path, title, body) => ({ label, path, blocks: { seo: { key: "seo", label: "SEO-titel en metabeschrijving", seo: true, title, body } } });
export const productTextKey = (path) => path.slice(1).replace(/-/g, "");

Object.assign(PAGE_TEXTS,
  Object.fromEntries(PRODUCT_PAGES.map((pp) => [productTextKey(pp.path), seoOnly(`${pp.label} (${pp.path})`, pp.path, pp.seo.title, pp.seo.description)])),
  {
    isde: seoOnly("ISDE-subsidie (/isde-subsidie-kozijnen)", "/isde-subsidie-kozijnen", ISDE_SEO.title, ISDE_SEO.description),
    offerte: seoOnly("Prijsindicatie aanvragen (/offerte-aanvragen)", "/offerte-aanvragen",
      "Prijsindicatie nieuwe kozijnen aanvragen | Maas Kozijn",
      "Vraag vrijblijvend een prijsindicatie aan voor kunststof of aluminium kozijnen, schuifpuien of deuren. Foto's uploaden kan. Gratis inmeten in Zuid-Holland."),
    vergelijken: seoOnly("Offerte vergelijken (/offerte-vergelijken)", "/offerte-vergelijken",
      "Kozijnofferte vergelijken en laten beoordelen | Maas Kozijn",
      "Al een offerte voor nieuwe kozijnen, een schuifpui of deur? Upload uw offerte of vul het bedrag in en laat hem vrijblijvend en persoonlijk beoordelen."),
    privacy: seoOnly("Privacybeleid (/privacy)", "/privacy", "Privacybeleid | Maas Kozijn",
      "Lees hoe Maas Kozijn omgaat met uw persoonsgegevens: welke gegevens wij verwerken, waarom, hoe lang en welke rechten u heeft volgens de AVG."),
  });
